import { useState, useEffect } from "react";
import axios from "axios";

// Generic anonymous react hook to fetch data from API.
// Uses axios.
const useApiGet = (url) => {
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [fetchFlag, setFetchFlag] = useState(0);

    useEffect(() => {
      fetchData(url);
    },[fetchFlag]);

    const fetchData = (url) => {
        axios
        .get(url)
        .then(response => {
            setIsLoaded(true);
            setData(response.data);
        })
        .catch(error => {
            setError(error);
        });
    };
    
    function triggerFetch() {
        // Set fetchFlag to indirectly trigger the useEffect above
        setData([]);
        setIsLoaded(false);
        setError(null);
        setFetchFlag(Math.random());
      }    

    return { error, isLoaded, data, triggerFetch };
  };
  
  export default useApiGet;